/* eslint-disable global-require */
const getEnvironment = () => {
  if (process.env.BUILD_ENV === 'production') {
    return require('./prod');
  }

  if (process.env.BUILD_ENV === 'qa') {
    return require('./qa');
  }

  if (process.env.BUILD_ENV === 'development') {
    return require('./dev');
  }

  throw new Error(
    `getEnvironment was called with an invalid process.env.BUILD_ENV of ${String(
      process.env.BUILD_ENV,
    )}`,
  );
};
/* eslint-enable global-require */

export const environment = getEnvironment().default;
